export default "__VITE_ASSET__CPb0ZbHl__"